module.exports = __webpack_public_path__ + "static/img/footer-wx.9f30339.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer-wx.jpg
// module id = /jEj
// module chunks = 1